import { Button } from '@m/alchemy-ui/Button';
import { CommunityRemovalStatus } from '../../../common/enums/CommunityRemovalStatus';
import { ButtonContainer, StatusContainer, StatusText } from './StatusCell.styled';

interface StatusCellProps {
  status: string;
  resetButtonClick: () => void;
  showOverallStatusReset?: boolean;
}

export const StatusCell = ({ status, resetButtonClick, showOverallStatusReset }: StatusCellProps) => {
  const mappedStatus =
    status === 'In Progress' ? CommunityRemovalStatus.InProgress : (status as CommunityRemovalStatus);
  const resetButtonText = 'Reset';

  const shouldShowReset =
    showOverallStatusReset === undefined ? mappedStatus === CommunityRemovalStatus.Fail : showOverallStatusReset;

  return (
    <StatusContainer data-testid="status-cell">
      <StatusText status={mappedStatus}>{status}</StatusText>
      {shouldShowReset && (
        <ButtonContainer>
          <Button
            destructive
            onClick={resetButtonClick}
            title="Resetting status back to scheduled"
            data-testid="status-reset-button"
          >
            {resetButtonText}
          </Button>
        </ButtonContainer>
      )}
    </StatusContainer>
  );
};
